export default {
  seniorFunder: {
    senior_funder_id: null,
    role_id: null,
    user_id: null,
  },
  originator: {
    originator_id: null,
    role_id: null,
    user_id: null,
  },
};
